import React from "react";

const STATUS = {
  confirmed: { label: "Confirmed", cls: "bg-[#0c1d12] border-[#1b3a25] text-[#86efac]" },
  pending: { label: "Pending", cls: "bg-[#1a1409] border-[#facc1544] text-[#facc15]" },
  partially_refunded: { label: "Part. refunded", cls: "bg-[#1a1409] border-[#3a2a0a] text-[#e8c987]" },
  refunded: { label: "Refunded", cls: "bg-[#1a1212] border-[#3a1a1a] text-[#fca5a5]" },
  cancelled: { label: "Cancelled", cls: "bg-[#1a1212] border-[#3a1a1a] text-[#fca5a5]" },
  failed: { label: "Failed", cls: "bg-[#1a1212] border-[#3a1a1a] text-[#fca5a5]" },
  swap_pending: { label: "Swap pending", cls: "bg-[#0e1320] border-[#1e2a44] text-[#93b4f5]" },
};

export function OrderStatusBadge({ status }) {
  const s = STATUS[status] || { label: status, cls: "bg-[#161616] border-[#2a2a2a] text-[#bbb]" };
  return (
    <span className={`inline-block text-[10px] uppercase tracking-wider px-2 py-1 rounded border whitespace-nowrap ${s.cls}`} data-testid={`status-${status}`}>
      {s.label}
    </span>
  );
}
